module.exports = __webpack_public_path__ + "img/team2_1.f52f9b47.jpg";